export default function TitleWithHint({ title, className }) {
    // hint = title={title}
    return (
        <div title={title} className={`${className}`}>{title}</div>
    )
}
